"use client";

import React from "react";
import { Navbar } from "@/components/ui/navbar";
import { Footer } from "@/components/ui/footer";
import {
	ThemeBackground,
	ThemeCard,
	ThemeText,
	AuroraBlobs,
} from "@/components/ui/theme-utils";
import { useTheme } from "@/hooks/useTheme";
import { cn } from "@/lib/utils";

export default function TermsPage() {
	const { isDark } = useTheme();

	return (
		<ThemeBackground className="min-h-screen flex flex-col">
			<Navbar />

			<main className="flex-grow">
				<section className="relative overflow-hidden pt-40 sm:pt-48 pb-12 sm:pb-16">
					<div
						className={cn(
							"absolute inset-0 -z-10",
							isDark ? "bg-mesh-dark" : "bg-mesh-light"
						)}
					/>
					<div
						className={cn(
							"absolute inset-0 -z-10 opacity-40",
							"bg-grid"
						)}
					/>
					<AuroraBlobs variant="mixed" />

					<div className="container relative z-10 mx-auto px-5 sm:px-6">
						<div className="mx-auto max-w-4xl">
							<div className="text-center mb-8">
								<h1 className="responsive-heading-2">
									Terms and <span className="text-gradient">Conditions</span>
								</h1>
								<ThemeText variant="subtle" className="mt-6 text-lg sm:text-xl leading-relaxed">
									Last updated: 12-12-2025
								</ThemeText>
							</div>

							<ThemeCard className="p-6 sm:p-10">
								<div className="space-y-4">
									<ThemeText>
										These Terms and Conditions, along with privacy policy or other terms (“Terms”) constitute a binding
										agreement by and between NOVARISE, ( “Website Owner” or “we” or “us” or “our”) and you (“you” or
										“your”) and relate to your use of our website, goods (as applicable) or services (as applicable)
										(collectively, “Services”).
									</ThemeText>

									<ThemeText>
										By using our website and availing the Services, you agree that you have read and accepted these Terms
										(including the Privacy Policy). We reserve the right to modify these Terms at any time and without
										assigning any reason. It is your responsibility to periodically review these Terms to stay informed of
										updates.
									</ThemeText>

									<ThemeText>
										The use of this website or availing of our Services is subject to the following terms of use:
									</ThemeText>

									<ul className="list-disc pl-6 space-y-4 marker:text-brand-500">
										<li>
											<ThemeText>
												To access and use the Services, you agree to provide true, accurate and complete information to us
												during and after registration, and you shall be responsible for all acts done through the use of your
												registered account.
											</ThemeText>
										</li>
										<li>
											<ThemeText>
												Neither we nor any third parties provide any warranty or guarantee as to the accuracy, timeliness,
												performance, completeness or suitability of the information and materials offered on this website
												or through the Services, for any specific purpose. You acknowledge that such information and
												materials may contain inaccuracies or errors and we expressly exclude liability for any such
												inaccuracies or errors to the fullest extent permitted by law.
											</ThemeText>
										</li>
										<li>
											<ThemeText>
												Your use of our Services and the website is solely at your own risk and discretion. You are
												required to independently assess and ensure that the Services meet your requirements.
											</ThemeText>
										</li>
										<li>
											<ThemeText>
												The contents of the Website and the Services are proprietary to Us and you will not have any
												authority to claim any intellectual property rights, title, or interest in its contents.
											</ThemeText>
										</li>
										<li>
											<ThemeText>
												You acknowledge that unauthorized use of the Website or the Services may lead to action against
												you as per these Terms or applicable laws.
											</ThemeText>
										</li>
										<li>
											<ThemeText>
												You agree to pay us the charges associated with availing the Services.
											</ThemeText>
										</li>
										<li>
											<ThemeText>
												You agree not to use the website and/ or Services for any purpose that is unlawful, illegal or
												forbidden by these Terms, or Indian or local laws that might apply to you.
											</ThemeText>
										</li>
										<li>
											<ThemeText>
												You agree and acknowledge that website and the Services may contain links to other third party
												websites. On accessing these links, you will be governed by the terms of use, privacy policy and
												such other policies of such third party websites.
											</ThemeText>
										</li>
										<li>
											<ThemeText>
												You understand that upon initiating a transaction for availing the Services you are entering into a
												legally binding and enforceable contract with the us for the Services.
											</ThemeText>
										</li>
										<li>
											<ThemeText>
												You shall be entitled to claim a refund of the payment made by you in case we are not able to
												provide the Service. The timelines for such return and refund will be according to the specific
												Service you have availed or within the time period provided in our policies (as applicable). In case
												you do not raise a refund claim within the stipulated time, than this would make you ineligible for
												a refund.
											</ThemeText>
										</li>
										<li>
											<ThemeText>
												Notwithstanding anything contained in these Terms, the parties shall not be liable for any failure to
												perform an obligation under these Terms if performance is prevented or delayed by a force majeure
												event.
											</ThemeText>
										</li>
										<li>
											<ThemeText>
												These Terms and any dispute or claim relating to it, or its enforceability, shall be governed by and
												construed in accordance with the laws of India.
											</ThemeText>
										</li>
										<li>
											<ThemeText>
												All disputes arising out of or in connection with these Terms shall be subject to the exclusive
												jurisdiction of the courts in LAL BANGLA, UTTAR PRADESH.
											</ThemeText>
										</li>
										<li>
											<ThemeText>
												All concerns or communications relating to these Terms must be communicated to us using the
												contact information provided on this website.
											</ThemeText>
										</li>
									</ul>
								</div>
							</ThemeCard>
						</div>
					</div>
				</section>
			</main>

			<Footer isHomePage={false} />
		</ThemeBackground>
	);
}
